import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { Box } from '@leagueplatform/genesis-core';

export const NODE_TYPE_BORDER_BOX = 'borderBox';

type BorderBoxProps = {};

type BorderBoxNode = MasonryEngineNode<
  typeof NODE_TYPE_BORDER_BOX,
  BorderBoxProps,
  {},
  {
    items: MasonryEngineNode<string, any>[];
  }
>;

export type BorderBoxRendererProps =
  MasonryEngineNodeRendererProps<BorderBoxNode>;

export function BorderBoxRenderer({ items }: BorderBoxRendererProps) {
  if (!items || !items.length) return null;

  return (
    <Box
      css={{
        paddingBlock: '$two',
        paddingInline: '$oneAndHalf',
        borderRadius: '$card',
        borderColor: '$onSurfaceBorderSubdued',
        borderStyle: 'solid',
        borderWidth: '$card',
      }}
    >
      {items}
    </Box>
  );
}
